"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectInput = void 0;
const react_1 = __importDefault(require("react"));
const MultiSelectMenu_1 = require("../Menus/MultiSelectMenu");
const BaseComponents_1 = require("./BaseComponents");
const utils_1 = require("./utils");
const MultiSelectInput = (props) => {
    const { options, label, width, blockDisplay, onOptionSelected } = props;
    const value = (0, utils_1.getMultiSelectValue)(options);
    return (react_1.default.createElement(MultiSelectMenu_1.MultiSelectMenu, { width: (0, utils_1.getWidthValue)(width), VisualElement: react_1.default.createElement(BaseComponents_1.SelectContainer, Object.assign({}, props, { className: "inputContainer" }),
            react_1.default.createElement(BaseComponents_1.SelectValueLabel, { value: value, label: label }),
            react_1.default.createElement(BaseComponents_1.SelectIcon, null)), onOptionSelected: onOptionSelected, menuOptions: options, menuLocation: blockDisplay ? 'below-block' : 'below' }));
};
exports.MultiSelectInput = MultiSelectInput;
exports.default = exports.MultiSelectInput;
//# sourceMappingURL=MultiSelectInput.js.map